import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { MobileCallBar } from "@/components/site/MobileCallBar";
import { SocialRail } from "@/components/site/SocialRail";

export const PageShell = ({ children }) => (
  <SmoothScroll>
    <div className="relative bg-void text-stark selection:bg-brand">
      <div className="grain" aria-hidden="true" />
      <Header />
      <main>{children}</main>
      <Footer />
      <MobileCallBar />
      <SocialRail />
      <div className="h-14 lg:hidden" aria-hidden="true" />
    </div>
  </SmoothScroll>
);
